import { FC, HTMLAttributes } from "react";
import { Typography, TypographyVariant, Image, Icon } from "@onmo/ui";
import clsx from "classnames";
import { useStyles } from "./ActivityCard.style";
import Gem from "../../../assets/icons/gem_1x.webp";
import Gem2x from "../../../assets/icons/gem_2x.webp";
import Gem3x from "../../../assets/icons/gem_3x.webp";
import { Activity, UserLeaderboardActivityData } from "@onmo/graphql/graphql";
import { Activities } from "../../../models/activities";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { useTranslation } from "react-i18next";

interface IActivityCardProps {
  activity: Activity;
}

const ActivityCard: FC<IActivityCardProps & HTMLAttributes<HTMLDivElement>> = ({
  activity,
  ...otherProps
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isLeaderboard = Activities.isLeaderboardActivity(activity);
  const isBattleActivity = Activities.isBattleActivity(activity);
  const card = Activities.contentCard(activity, t, i18n.language);
  const { src, title, rank, gem } = card;

  const onClickCard = () => {
    if (!isLeaderboard) return;
    const lbData = activity.data as UserLeaderboardActivityData;
    navigate(
      `${PageRoutes.LeaderboardActivity}/${lbData.leaderboardId}?type=${lbData.repeatCycle}`,
    );
  };

  return (
    <div className={classes.activityCard} {...otherProps} onClick={onClickCard}>
      <div className={classes.label}>
        <Image
          className={clsx(isBattleActivity && classes.img)}
          src={src.src1x}
          src2x={src.src2x}
          src3x={src.src3x}
        />
        <div>
          <Typography variant={TypographyVariant.BodyB5Regular}>
            {title}
          </Typography>
          {rank && (
            <Typography variant={TypographyVariant.BodyB4Bold}>
              {rank}
            </Typography>
          )}
        </div>
      </div>
      {gem ? (
        <Typography
          variant={TypographyVariant.BodyB4Bold}
          className={classes.value}
        >
          <Image src={Gem} src2x={Gem2x} src3x={Gem3x} /> {gem}
        </Typography>
      ) : rank ? (
        <Icon name="icon-linear-arrow-right-3" />
      ) : null}
    </div>
  );
};

export default ActivityCard;
